var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggles"},[_c('h2',[_vm._v(_vm._s(_vm.content.headline))]),_c('p',[_vm._v(_vm._s(_vm.content.text))]),_vm._l((_vm.content.items),function(item,index){return _c('toggle-box',{key:index,attrs:{"item":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }